export function hexToRgb(hex: string) {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  // Converte para os componentes RGB
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
}

export function validaCPF(cpf: string) {
  let Soma = 0
  let Resto

  var strCPF = String(cpf).replace(/[^\d]/g, '')

  if (strCPF.length !== 11)
    return false

  if ([
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ].indexOf(strCPF) !== -1)
    return false

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

  Resto = (Soma * 10) % 11

  if ((Resto == 10) || (Resto == 11))
    Resto = 0

  if (Resto != parseInt(strCPF.substring(9, 10)))
    return false

  Soma = 0

  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)

  Resto = (Soma * 10) % 11

  if ((Resto == 10) || (Resto == 11))
    Resto = 0

  if (Resto != parseInt(strCPF.substring(10, 11)))
    return false

  return true
}

export function testPhones(values: any): boolean {
  if (!Array.isArray(values)) return false;

  const clearPhones = values.map((phone: string) => phone.replace(/\D/g, '')).filter((phone: string) => phone.length > 0);

  if (clearPhones.length === 0) return true;

  const phonePattern = /^\d{10,11}$/;
  return clearPhones.every((phone: string) => phonePattern.test(phone));
}